import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const RouteChangesListener = () => {
	const { pathname } = useLocation();

	useEffect(() => {
		// scroll restoration
		window.scrollTo(0, 0);
	}, [pathname]);

	return null;
};

export default RouteChangesListener;
